async function updateBundleInCartDrawer() {
  try {
    // 1. Warenkorb-Daten laden
    const cart = await fetch('/cart.js').then(r => r.json());
    if (!cart?.items?.length) return;
    const bundleItem = cart.items.find(item => item.properties && item.properties.Items);
    if (!bundleItem) return;

    // 2. Produkt-Titel extrahieren
    const productTitles = bundleItem.properties.Items.split(',')
      .map(x => x.trim().replace(/^\d+\s*x\s+/i, '').replace(/^\d+\s+x\s+/i, ''))
      .filter(Boolean);

    // 3. Produkte anhand Titel über Shopify Suggest suchen
    const getProductByExactTitle = async (title) => {
      try {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(title)}&resources[type]=product&limit=8`);
        if (!res.ok) return null;
        const data = await res.json();
        const prods = data.resources?.results?.products || [];
        return prods.find(p => p.title === title);
      } catch {
        return null;
      }
    };
    const products = await Promise.all(productTitles.map(getProductByExactTitle));
    const validProducts = products.filter(Boolean);
    if (!validProducts.length) return;

    // 4. Alle passenden Inputs im (Shadow)DOM suchen
    function deepQuerySelectorAll(selector, root = document) {
      let results = Array.from(root.querySelectorAll(selector));
      root.querySelectorAll('*').forEach(el => {
        if (el.shadowRoot) results = results.concat(deepQuerySelectorAll(selector, el.shadowRoot));
      });
      return results;
    }
    const inputs = deepQuerySelectorAll(`[data-line-key="${bundleItem.key}"]`);
    if (!inputs.length) return;

    // 5. line-item-Element finden
    let node = inputs[0];
    while (node && node.tagName !== 'LINE-ITEM') {
      if (node.getRootNode && node.getRootNode().host) {
        node = node.getRootNode().host;
      } else {
        node = node.parentNode;
      }
    }
    if (!node) return;
    const lineItem = node;

    // 6. Vorherige Bundle-Anzeige entfernen
    lineItem.parentNode.querySelectorAll('.easy-bundle-container').forEach(e => e.remove());

    // 7. Rabatt und Preise berechnen
    const gesamtAnzahl = validProducts.length;
    const originalPreis = validProducts.reduce((sum, p) => sum + Number(p.price), 0);
    let rabattProzent = 0;
    if (gesamtAnzahl === 4) rabattProzent = 8;
    else if (gesamtAnzahl === 6) rabattProzent = 12;
    const rabattFaktor = rabattProzent ? (1 - rabattProzent / 100) : 1;
    const rabattierterPreis = originalPreis * rabattFaktor;
    const formatEuro = p => Number(p).toFixed(2).replace('.', ',');

    // 8. HTML-Bundle-Ausgabe inkl. rabattierter Einzelpreise
    const bundleContainer = document.createElement('div');
    bundleContainer.className = 'easy-bundle-container';
    bundleContainer.style.marginTop = '10px';
    bundleContainer.innerHTML = `
      <div style="border-top:1px solid #ddd;padding-top:10px;">
        <h4 style="font-weight:bold;margin-bottom:10px;">Bundle-Inhalt:</h4>
        <div style="margin-bottom:14px;">
          <span style="color:#555;font-size:18px;font-weight:bold;">
            ${formatEuro(rabattierterPreis)} €
          </span>
          <span style="font-size:15px;color:#d00;text-decoration:line-through;margin-left:10px;">
            ${formatEuro(originalPreis)} €
          </span>
          ${rabattProzent > 0 ?
            `<span style="color:#097;font-weight:bold;font-size:14px;margin-left:10px;">(${rabattProzent}% Rabatt)</span>`
            : ''}
        </div>
        ${validProducts.map(p => `
          <div style="display:flex;align-items:center;margin-bottom:8px;">
            <img src="${p.image}" alt="${p.title}" width="48" height="48" style="border-radius:8px;margin-right:10px;">
            <div>
              <div style="font-size:14px;font-weight:500;">${p.title}</div>
              <div>
                <span style="font-size:13px; color:#555;">
                  ${formatEuro(Number(p.price) * rabattFaktor)} €
                </span>
                <span style="font-size:12px; color:#d00; text-decoration:line-through; margin-left:8px;">
                  ${formatEuro(Number(p.price))} €
                </span>
              </div>
            </div>
          </div>
        `).join('')}
      </div>
    `;

    // 9. Direkt nach <line-item> ins DOM einfügen!
    lineItem.insertAdjacentElement('afterend', bundleContainer);

  } catch (err) {
    console.error('Easy Bundle Script Fehler:', err);
  }
}

// Beim Seitenladen, Window-Load & cart:change ausführen
document.addEventListener('DOMContentLoaded', updateBundleInCartDrawer);
window.addEventListener('load', updateBundleInCartDrawer);
document.addEventListener('cart:change', updateBundleInCartDrawer);